<template>
    <v-card class="geo-map-overlay">
        <v-list-item v-for="(item, index) of computedData" :key="index" class="px-2" dense>
            <v-list-item-icon class="mr-2 ml-0">
                <v-icon :color="item.color">mdi-circle</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title class="mr-1">({{ item.quantity }}) {{ item.name }}</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
    </v-card>
</template>

<script>
import { colors } from '../../../plugins/vuetify.ts'
    export default {
        props: {
            data: {
                required: false,
                default: () => []
            },
        },
        computed: {
            computedData() {
                // Loop through all features and group data for like RQ bands
                let groupedFeatures = []

                for (const feature of this.data) {
                    let name = ""
                    let color = ""
                    let quantity = feature.length // number of papers per point

                    if (feature[0].rq === 0) { // only need to access first entry to determine the RQ band
                        name = "No Detects"
                        color = colors.noDetect
                    }
                    else if (feature[0].rq <= 0.1) {
                        name = "Insignificant Risk"
                        color = colors.insignificant
                    }
                    else if (feature[0].rq <= 1.0) {
                        name = "Low Risk"
                        color = colors.low
                    }
                    else if (feature[0].rq <= 10.0) {
                        name = "Moderate Risk"
                        color = colors.med
                    }
                    else {
                        name = "High Risk"
                        color = colors.high
                    }

                    let obj = {
                        name : name,
                        quantity: quantity,
                        color: color
                    }

                    // determine if RQ band already exists in list, if so add it's quantity, else add to list
                    const index = groupedFeatures.findIndex((e) => e.name === obj.name)

                    if (index === -1) {
                        groupedFeatures.push(obj)
                    }
                    else {
                        groupedFeatures[index].quantity += quantity
                    }
                }
                return groupedFeatures
            },
        },
    }
</script>

<style scoped>
    .geo-map-overlay {
        position: absolute;
        z-index: 1;
        max-height: 300px;
        overflow: hidden;
        top: 10px;
        right: 10px;
    }
</style>